import { api } from './client.js';

export const filesApi = {
  upload: (file) => api.uploadFile('/api/files', file),
  getUrl: (id) => `/api/files/${id}`,
  archive: (id) => api.delete(`/api/files/${id}`),
  // Speaker portal upload — sends X-Speaker-Token instead of JWT
  uploadAsPortal: (token, file) =>
    fetch('/api/files', {
      method: 'POST',
      headers: {
        'Content-Type': file.type,
        'X-Filename': file.name,
        'X-Speaker-Token': token,
      },
      body: file,
    }).then(async (r) => {
      if (!r.ok) throw new Error((await r.json()).error ?? 'Upload failed');
      return r.json();
    }),
};
